import {
  PROMOTE_PROVIDER,
  PROMOTE_PROVIDER_FAILURE,
  PROMOTE_PROVIDER_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const promoteProviderReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROMOTE_PROVIDER:
      return { ...state, loading: true };
    case PROMOTE_PROVIDER_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case PROMOTE_PROVIDER_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default promoteProviderReducer;
